import { render, staticRenderFns } from "./editTeachingSecond.vue?vue&type=template&id=33cb21b3&scoped=true&"
import script from "./editTeachingSecond.vue?vue&type=script&lang=js&"
export * from "./editTeachingSecond.vue?vue&type=script&lang=js&"
import style0 from "./editTeachingSecond.vue?vue&type=style&index=0&id=33cb21b3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb21b3",
  null
  
)

export default component.exports